export var backButtonContainer = function backButtonContainer(theme) {
  return {
    position: 'absolute',
    top: 0,
    right: 'calc(100% + 12px)',
    border: "1px solid ".concat(theme.gray200),
    borderRadius: 4,
    padding: '0.5em',
    color: theme.gray500,
    transition: 'all .3s ease-in-out',
    '&:hover, &:active': {
      backgroundColor: theme.gray200,
      color: theme.white
    },
    '@media (max-width: 1399px)': {
      position: 'relative',
      right: 0,
      display: 'inline-block',
      marginBottom: '1em'
    }
  };
};